import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTasksService } from './data-tasks.service';
import { DataTasksLogicService } from './data-tasks/data-tasks-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [{ provide: DataTasksService, useClass: DataTasksLogicService }]
})
export class DataTasksModule {}
